// import React from "react";
import {
  FaPhoneAlt,
  FaFacebook,
  FaMapMarkerAlt,
  FaEnvelope,
  FaTiktok,
} from "react-icons/fa";
import { SiZalo } from "react-icons/si";
import { LuCar } from "react-icons/lu";
import { Link } from "react-router-dom";
import logoImage from "../assets/logo_qdriver.png";
import certificate from "../assets/certificate.jpg";
import footerBg from "../assets/footer-bg.avif";

const Footer = () => {
  return (
    <footer className="relative bg-gray-900 text-white pt-8 px-6 mt-auto">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{
          backgroundImage: `url(${footerBg})`,
          filter: "brightness(40%)",
        }}
      ></div>
      <div className="relative max-w-7xl mx-auto flex flex-col sm:flex-row justify-center items-start gap-y-8 gap-x-32 text-center sm:text-left">
        {/* Cột 1: Logo & mô tả */}
        <div className="w-full sm:w-auto max-w-sm">
          <img
            src={logoImage}
            alt="Logo Quốc Dạy Lái Xe"
            className="h-18 mb-2 object-contain"
          />
          <h2 className="text-xl text-center -mt-2 font-bold">
            Đào Tạo Lái Xe Cùng Quốc
          </h2>
          {/* <p className="text-gray-300 mt-2">
            Trung tâm dạy lái xe uy tín tại TP. HCM - Đào tạo chất lượng, tận
            tâm.
          </p> */}
        </div>

        {/* Cột 2: Thông tin liên hệ */}
        <div className="w-full sm:w-auto max-w-sm text-gray-300 text-sm space-y-3">
          <h2 className="text-xl font-bold">THÔNG TIN LIÊN HỆ</h2>
          <div className="flex items-center gap-2">
            <FaPhoneAlt />{" "}
            <a href="tel:0786529313" className="hover:text-white">
              078 652 9313
            </a>
          </div>
          <div className="flex items-center gap-2">
            <FaPhoneAlt />{" "}
            <a href="tel:0786529313" className="hover:text-white">
              078 652 9313
            </a>
          </div>
          <div className="flex items-center gap-2">
            <FaEnvelope />{" "}
            <a
              href="mailto:nguyenlethanhquoc.181286@gmail.com"
              className="hover:text-white"
            >
              nguyenlethanhquoc.181286@gmail.com
            </a>
          </div>
          <div className="flex items-center gap-2">
            <FaMapMarkerAlt /> 60/12B Đ Lồ Ô, Phường Đông Hòa, Thành phố Hồ Chí
            Minh, Việt Nam
          </div>

          {/* Mạng xã hội */}
          <div className="flex gap-5 mt-2">
            <a
              href="https://zalo.me/0786529313"
              target="_blank"
              rel="noopener noreferrer"
              title="Zalo"
              className="bg-white p-2 rounded-full shadow-md hover:opacity-80 transition-opacity inline-flex items-center justify-center"
            >
              <SiZalo size={24} color="#0068FF" />
            </a>
            <a
              href="https://facebook.com/daylaixe.quoc"
              target="_blank"
              rel="noopener noreferrer"
              title="Facebook"
              className="bg-white p-2 rounded-full shadow-md hover:opacity-80 transition-opacity inline-flex items-center justify-center"
            >
              <FaFacebook size={24} color="#1877F2" />
            </a>
            <a
              href="https://www.google.com/maps/place/10%C2%B053'51.8%22N+106%C2%B047'48.5%22E/@10.897708,106.7942384,17z/data=!3m1!4b1!4m7!1m2!10m1!1e2!3m3!8m2!3d10.897708!4d106.7968133?entry=ttu&g_ep=EgoyMDI1MDgxOS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              title="Bản đồ"
              className="bg-white p-2 rounded-full shadow-md hover:opacity-80 transition-opacity inline-flex items-center justify-center"
            >
              <FaMapMarkerAlt size={24} color="#EA4335" />
            </a>
            <a
              href="https://www.tiktok.com/@quocdaylaixehochiminh"
              target="_blank"
              rel="noopener noreferrer"
              title="TikTok"
              className="bg-white p-2 rounded-full shadow-md hover:opacity-80 transition-opacity inline-flex items-center justify-center"
            >
              <FaTiktok size={24} color="#000000" />
            </a>
          </div>
        </div>

        {/* ✅ Cột 3: Khóa học */}
        <div className="w-full sm:w-auto max-w-sm text-gray-300 text-sm space-y-3">
          <h2 className="text-xl font-bold">CÁC KHÓA HỌC</h2>
          <ul className="space-y-1">
            <li><Link to="/khoa-hoc/khóa-học-a1" className="hover:underline">Bằng A1 - Xe máy phổ thông</Link></li>
            <li><Link to="/khoa-hoc/khóa-học-a2" className="hover:underline">Bằng A - Mô tô phân khối lớn</Link></li>
            <li><Link to="/khoa-hoc/khóa-học-b1" className="hover:underline">Bằng B - Ô tô số tự động</Link></li>
            <li><Link to="/khoa-hoc/khóa-học-b2" className="hover:underline">Bằng B - Ô tô số sàn</Link></li>
            {/* <li><Link to="/khoa-hoc/khóa-học-lái-xe-hạng-c-lái-xe-tải-chuyên-nghiệp,-mở-rộng-cơ-hội-việc-làm" className="hover:underline">Bằng C - Xe tải</Link></li>
            <li><Link to="/khoa-hoc/khóa-học-lái-xe-hạng-d-lái-xe-khách-chuyên-nghiệp-nâng-cao-tay-nghề" className="hover:underline">Bằng D - Xe khách 10-30 chỗ</Link></li> */}
            {/* <li>Bằng E - Xe khách trên 30 chỗ</li> */}
            {/* <li>Bằng F - Rơ moóc, sơ mi rơ moóc</li> */}
          </ul>
        </div>
      </div>

      {/* Mini Map và Hình ảnh nhà */}
      <div className="relative max-w-7xl mx-auto mt-8 px-4">
        <h3 className="text-lg font-semibold text-gray-200 mb-4 text-center">
          Vị trí trung tâm & hình ảnh thực tế
        </h3>
        <div className="flex flex-col md:flex-row items-center justify-center gap-6">
          {/* Google Map nhúng */}
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3917.866782932395!2d106.79423067427307!3d10.897727456946134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTDCsDUzJzUxLjgiTiAxMDbCsDQ3JzQ4LjUiRQ!5e0!3m2!1svi!2s!4v1755761153912!5m2!1svi!2s"
            width="100%"
            height="330"
            className="rounded-md md:w-1/2 border-2 border-white"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

          {/* Ảnh nhà */}
          <img
            src={certificate}
            alt="Ảnh trung tâm"
            className="w-full md:w-1/2 max-w-md rounded-md shadow-lg object-cover border-2 border-white"
          />
        </div>
      </div>

      {/* Bản quyền */}
      <p className="relative text-gray-300 text-sm sm:text-base mt-8 text-center pb-10 flex justify-center items-center gap-2">
        © 2025 Quốc Dạy Lái Xe - Đào tạo lái xe uy tín - chất lượng hàng đầu.
        All rights reserved.
        <span className="text-white-500 animate-bounce">
          <LuCar size={40} />
        </span>
      </p>
    </footer>
  );
};

export default Footer;
